import React from 'react'
import { Videos } from './videos'

export class Images extends Videos {
  getType = () => "images"
  usesPreview = () => false
}
